import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IneService {

  urlServices = environment.urlService;

  constructor(private http: HttpClient) {
  }

  ineFacial(data: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Basic bnViYXJpdW06X251YjRyMXVtcDRzc3cwcmQu`
    });
    const options = {headers};
    return this.http.post(`https://dev-api.autofy.mx/business/antifraude/reconocimiento_facial`, data, options);
  }

  validaCurp(data: any) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Basic bnViYXJpdW06X251YjRyMXVtcDRzc3cwcmQu`
    });
    const options = {headers};
    return this.http.post(`https://dev-api.autofy.mx/business/renapo/valida_curp`, data, options);
  }

  obtenerDatosIne(data: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Basic bnViYXJpdW06X251YjRyMXVtcDRzc3cwcmQu`
    });
    const options = {headers};
    return this.http.post(`https://dev-api.autofy.mx/business/ocr/obtener_datos`, data, options);
  }


}
